const IMAGES = {
  // Bodegón premium — cuadrada con tarjeta de marca
  p1: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/5hgtkaoq_freepik__bodegn-final-con-iluminacin-clida-y-sofisticada-mo__52059.png',
  // Croqueta rota con vapor y bechamel — iluminación cálida
  p2: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/awkkg4qm_Croquette_broken_in_202604040917%20%281%29.jpeg',
  // Croqueta rota — fondo oscuro dramático
  p3: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/14enhs0a_Croquette_broken_in_202604040917%20%282%29.jpeg',
  // Croqueta rota — versión original rústica
  p4: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/rpuhurm7_Croquette_broken_in_202604040917.jpeg',
  // Primer plano interior con relleno visible
  p5: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/t991qvg7_freepik__escena-2-textura-y-sonido-primersimo-plano-en-slow__52057.png',
  // Fotos reales del catálogo
  atunyquesito: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/zseitaf6_Atunyquesito_cleanup.jfif',
  bacalao: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/xbvmik4w_bacalao_cleanup.jfif',
  cecinaypuerro: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/fibtcdwn_cecinaypuerro_cleanup.jfif',
  chistorra: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/hwg3wh64_Chistorra%20y%20miel%20_cleanup.jfif',
  chorizodeteror: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/9uyk8zqt_chorizodeteror_cleanup.jfif',
  iberico: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/bgyac74o_Iberico.png',
  merluza: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/ee7svwqe_Merluza_cleanup.jfif',
  pizza: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/kcyxidzb_pizza2.png',
  pollo: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/ru50qd6e_pollo_cleanup.jfif',
  setasyparmesano: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/u0gl38nt_setasyparmesano_cleanup.jfif',
  polloCurry: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/gnajpe33_pollo-curry_cleanup.jfif',
  espinacas: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/rohzelk8_Espinacasyparmesano_cleanup.jfif',
  morcilla: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/h7wphsxw_Morzillaymanzanaf_cleanup.jfif',
  rulocabra: 'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/oapj4ln7_rulodecabraymiel.jfif',
};

export const products = [
  // Carnes
  {
    id: 1, name: 'Ibérico', category: 'Carnes', price: 1.10,
    description: 'Jamón ibérico de bellota en bechamel artesanal. Nuestra joya.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.iberico, featured: true,
  },
  {
    id: 2, name: 'Pollo', category: 'Carnes', price: 0.85,
    description: 'Pollo de corral con bechamel cremosa casera.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.pollo,
  },
  {
    id: 3, name: 'Pollo Curry', category: 'Carnes', price: 0.90,
    description: 'Pollo al curry especiado con nueces tostadas.',
    allergens: ['Gluten', 'Leche', 'Frutos Secos'], image: IMAGES.polloCurry, warning: 'Contiene nueces',
  },
  {
    id: 4, name: 'Morcilla y Manzana', category: 'Carnes', price: 0.95,
    description: 'Morcilla artesanal con manzana caramelizada.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.morcilla,
  },
  {
    id: 5, name: 'Chorizo de Teror con Miel de Azahar', category: 'Carnes', price: 1.00,
    description: 'Chorizo de Teror con miel de Azahar canaria.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.chorizodeteror,
  },
  {
    id: 6, name: 'Cecina y Puerro', category: 'Carnes', price: 0.92,
    description: 'Cecina curada con puerro pochado en bechamel.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.cecinaypuerro,
  },
  {
    id: 7, name: 'Chistorra con Miel de Azahar', category: 'Carnes', price: 0.98,
    description: 'Chistorra crujiente con toque de miel de Azahar.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.chistorra,
  },
  // Pescados
  {
    id: 8, name: 'Merluza', category: 'Pescados', price: 0.95,
    description: 'Merluza fresca del norte con bechamel suave.',
    allergens: ['Gluten', 'Leche', 'Pescado'], image: IMAGES.merluza,
  },
  {
    id: 9, name: 'Bacalao', category: 'Pescados', price: 0.98,
    description: 'Bacalao desalado con aceite de oliva virgen extra.',
    allergens: ['Gluten', 'Leche', 'Pescado'], image: IMAGES.bacalao,
  },
  {
    id: 10, name: 'Atún y Quesito', category: 'Pescados', price: 0.92,
    description: 'Atún en aceite con quesito canario cremoso.',
    allergens: ['Gluten', 'Leche', 'Pescado'], image: IMAGES.atunyquesito,
  },
  // Vegetarianas
  {
    id: 11, name: 'Espinacas y Parmesano', category: 'Vegetarianas', price: 0.88,
    description: 'Espinacas frescas salteadas con parmesano italiano.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.espinacas,
  },
  {
    id: 12, name: 'Setas y Parmesano', category: 'Vegetarianas', price: 0.90,
    description: 'Setas de temporada salteadas con parmesano curado.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.setasyparmesano,
  },
  {
    id: 13, name: 'Rulo de Cabra y Miel de Azahar', category: 'Vegetarianas', price: 1.05,
    description: 'Queso de rulo de cabra con miel de Azahar canaria.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.rulocabra,
  },
  {
    id: 14, name: 'Pizza', category: 'Vegetarianas', price: 0.82,
    description: 'Tomate, mozzarella y hierbas mediterráneas.',
    allergens: ['Gluten', 'Leche'], image: IMAGES.pizza,
  },
];

export const categories = ['Todos', 'Carnes', 'Pescados', 'Vegetarianas'];
